const themeConfig = {
  WOMEN: "women",
  MEN: "men",
}

export default themeConfig
